export const ETSY_LINK_V1_ROUTE_PATH_SEGMENT = 'etsy/link/v1';
export const ETSY_LINK_V2_ROUTE_PATH_SEGMENT = 'etsy/link/v2';
export const ETSY_API_VERSION_1 = 1;
export const ETSY_API_VERSION_2 = 2;
